<template>
	<div class="row">
		<div class="small-12 medium-8 medium-offset-2">
			<div class="flex-video">
				<iframe 
					v-if="canShowVideo" 
					:src="data.src.replace('watch?v=', 'embed/')" 
					width="560" 
					height="315" 
					frameborder="0" 
					allowfullscreen></iframe>

					<cookie-consent-fallback-message 
						v-if="!canShowVideo"
						:type="'video'" 
						:externalSite="'Vimeo'" 
						:externalUrl="data.src" />

			</div>
		</div>
	</div>
</template>


<script>
import { ConsentVideo } from 'DcVueCookiebot/mixins/ConsentVideo.js'
export default {
	props: ['data'],
	mixins: [ConsentVideo],
	components: {
		CookieConsentFallbackMessage: () => import('DcVueCookiebot/components/global/CookieConsentFallbackMessage'),
	},
}
</script>